// Import the app dependencies from npm repo
import jquery from './lib/jquery.shim'
import bootstrap from 'bootstrap'

// Import your custom dependencies from a js file
import customLib from './lib/custom-lib'

// Export for declarative use in your application
export { customLib, jquery, bootstrap }
